import { Badge } from 'core-ui';
import { RoutePath } from 'src/enums/routePath';
import { PROFILE_NAME } from 'src/constants/auth';
import useHandleNetwork from 'src/hooks/useHandleNetwork';
import { useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { isOnline } = useHandleNetwork();
  const renderTitle = () => {
    if (currentPath?.includes(RoutePath.CREATE)) {
      return 'Create';
    }
    if (currentPath?.includes(RoutePath.DETAIL)) {
      return 'Detail';
    }
    if (currentPath?.includes(RoutePath.EDIT)) {
      return 'Edit';
    }
    if (currentPath?.includes(RoutePath.ANALYTIC)) {
      return 'Analytic';
    }
    if (currentPath?.includes(RoutePath.COMPANY_REGISTRATION_MANAGEMENT)) {
      return 'Company registration management';
    }
    if (
      currentPath?.includes(RoutePath.COMPANY_ADMIN) ||
      currentPath?.includes(RoutePath.COMPANY_STAFF)
    ) {
      return 'Account management';
    }
    if (currentPath?.includes(RoutePath.COMPANY)) {
      return 'Company management';
    }
    if (currentPath?.includes(RoutePath.PRODUCT)) {
      return 'Product management';
    }
    if (currentPath?.includes(RoutePath.REPORT)) {
      return 'Report management';
    }
    if (currentPath?.includes(RoutePath.HISTORY_SCAN)) {
      return 'History Scan';
    }
    if (currentPath?.includes(RoutePath.STICKER)) {
      return 'Sticker purchase list';
    }
    if (currentPath?.includes(RoutePath.CHANGE_PASSWORD)) {
      return 'Change Password';
    }
    if (currentPath?.includes(RoutePath.RENEWAL)) {
      return 'Renewal management list';
    }
    if (currentPath?.includes(RoutePath.SYSTEM_ADMIN)) {
      return 'System admin';
    }
    if (currentPath?.includes(RoutePath.SETTING)) {
      return 'Setting';
    }
  };
  return (
    <div className="h-[100%] flex items-center justify-between px-[20px] bg-[#ffffff]">
      <p className="text-primary text-[24px] font-[500]">{renderTitle()}</p>
      <div className="flex items-center">
        <div className="flex items-center">
          <div className="mr-[20px] flex">
            <Badge
              color="green"
              offset={[14, 10]}
              style={{
                display: isOnline ? 'block' : 'none',
                height: '10px',
                width: '10px'
              }}
            >
              <div className="flex flex-col ml-[8px]">
                <p className="leading-[20px] font-[500] text-[#434343] text-[16px] min-w-[60px]">
                  {localStorage.getItem(PROFILE_NAME)}
                </p>
              </div>
            </Badge>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
